{
  "welcome": "Bienvenido, {{name}}",
  "description": "Resumen de la Cuenta",
  "nextSettlement": "Próxima liquidación: {{time}}",
  "adminAlert": {
    "title": "Acción Requerida: Inicializar Capital Base",
    "description": "Debe establecer su capital base inicial (mínimo $10,000) antes de que el sistema pueda funcionar.",
    "button": "Inicializar Capital Base Ahora"
  },
  "userInfo": {
    "email": "Correo Electrónico",
    "country": "País",
    "unitedStates": "Estados Unidos",
    "nonUsa": "Fuera de EE. UU.",
    "countryNote": "(Usado para reglas de tarifas. Inmutable.)",
    "earningEligibility": "Elegibilidad de Ganancias",
    "eligible": "ELEGIBLE PARA GANANCIAS",
    "notEligible": "NO ELEGIBLE",
    "shortfallNote": "(Necesita {{amount}} más para alcanzar la contribución mínima)"
  },
  "stats": {
    "basePrincipal": "Capital Base",
    "ownership": "Propiedad",
    "ownershipTooltip": "Su porcentaje del fondo total, calculado desde la instantánea de propiedad S13",
    "thisWeeksProfit": "Ganancia de Esta Semana",
    "withdrawable": "Retirable",
    "requestButton": "Solicitar"
  },
  "performance": {
    "title": "Resumen de Rendimiento",
    "week": "Semana Actual",
    "month": "Mes Actual",
    "ytd": "Año Actual",
    "allTime": "Histórico"
  },
  "profitSettings": {
    "title": "Configuración de Ganancias",
    "notEligibleTag": "NO ELEGIBLE PARA GANANCIAS",
    "reinvestmentPercentage": "Porcentaje de Reinversión",
    "reinvestmentTooltip": "Arrastre el control deslizante para ajustar qué porcentaje de su ganancia semanal se reinvertirá en su capital base. El resto se agregará a su saldo retirable.",
    "saveButton": "Guardar",
    "unsavedChanges": "Cambios No Guardados",
    "previewTitle": "Vista previa (basada en la ganancia actual):",
    "basePrincipal": "→ Capital Base",
    "withdrawable": "→ Retirable",
    "addedOnSettlement": "Agregado en liquidación",
    "notEligibleAlert": {
      "title": "No Elegible para Ganancias",
      "description": "Necesita contribuir {{amount}} más para alcanzar la contribución mínima requerida y comenzar a ganar."
    },
    "saveSuccess": "Porcentaje de reinversión guardado",
    "saveError": "Error al guardar el porcentaje de reinversión",
    "invalidPercentage": "Porcentaje inválido. Debe estar entre 0 y 100."
  },
  "oneTimeWithdraw": {
    "button": "Retiro único",
    "modalTitle": "Asignación de Retiro Único",
    "currentProfit": "Ganancia Actual de la Semana",
    "amountLabel": "Cantidad a mover a retirable",
    "helpText": "Esta es una asignación única que se aplicará en la próxima liquidación del sábado. No cambia su % de reinversión.",
    "maxError": "La cantidad no puede exceder la ganancia actual de la semana",
    "minError": "La cantidad debe ser mayor o igual a 0",
    "saveButton": "Guardar",
    "cancelButton": "Cancelar",
    "clearButton": "Limpiar",
    "saveSuccess": "Cantidad de retiro único establecida exitosamente",
    "clearSuccess": "Cantidad de retiro único eliminada",
    "saveError": "Error al establecer la cantidad de retiro único",
    "pendingLabel": "Único a retirable (pendiente):",
    "remainingNote": "La ganancia restante seguirá su % de reinversión normal."
  },
  "recentAllocations": {
    "title": "Asignaciones Recientes",
    "viewAll": "Ver Todo",
    "date": "Fecha",
    "gross": "Bruto",
    "companyCut": "Tarifas",
    "net": "Neto",
    "noAllocations": "Aún no hay asignaciones de ganancias. Las asignaciones aparecerán aquí después de que se distribuyan las ganancias."
  },
  "withdrawModal": {
    "title": "Solicitar Retiro",
    "processingTime": {
      "title": "Tiempo de Procesamiento del Retiro",
      "description": "Las solicitudes de retiro generalmente se procesan dentro de 1-3 días hábiles."
    },
    "amount": "Cantidad",
    "available": "(Disponible: {{amount}})",
    "amountRequired": "Por favor ingrese una cantidad",
    "amountGreaterThanZero": "La cantidad debe ser mayor que 0",
    "amountExceedsBalance": "La cantidad excede el saldo disponible",
    "placeholder": "Ingrese la cantidad en centavos",
    "noteLabel": "Nota (Opcional)",
    "notePlaceholder": "Agregue una nota sobre esta solicitud de retiro",
    "cancelButton": "Cancelar",
    "submitButton": "Enviar Solicitud",
    "submitSuccess": "Solicitud de retiro enviada exitosamente",
    "submitError": "Error al enviar la solicitud de retiro"
  },
  "accountClosure": {
    "requestButton": "Solicitar Cierre de Cuenta",
    "modalTitle": "Solicitar Cierre de Cuenta",
    "warningTitle": "Importante: Esta acción iniciará el proceso de cierre de cuenta",
    "warningMessage": "Una vez enviada, su solicitud para salir del fondo se procesará durante la próxima liquidación semanal. Esto es lo que sucederá:",
    "step1": "Recibirá una asignación de ganancia final en la próxima liquidación",
    "step2": "Se creará automáticamente un retiro final por todo su saldo retirable (incluida la ganancia final)",
    "step3": "Su capital base se establecerá en $0.00",
    "step4": "El estado de su cuenta se cambiará a 'salido' y ya no recibirá asignaciones de ganancias",
    "explanation": "Si continúa, seguirá recibiendo una asignación de ganancias más en la próxima liquidación semanal. Una vez que se complete esa liquidación, el sistema creará automáticamente un retiro final por todo su saldo retirable, y ya no participará en futuras distribuciones de ganancias.",
    "confirmCheckbox": "Entiendo que esta acción no se puede deshacer y mi cuenta se cerrará",
    "cancelButton": "Cancelar",
    "confirmButton": "Confirmar Solicitud de Cierre",
    "successTitle": "Solicitud Enviada",
    "successMessage": "Su solicitud de cierre de cuenta ha sido enviada y está pendiente de aprobación del administrador. Ya no recibirá nuevas asignaciones de ganancias.",
    "errorTitle": "Solicitud Fallida",
    "errorMessage": "Error al enviar la solicitud de cierre. Por favor, inténtelo de nuevo."
  },
  "closureStatus": {
    "pendingTitle": "Cierre de Cuenta Pendiente",
      "pendingMessage": "Su solicitud de cierre de cuenta está pendiente de aprobación del administrador. Ya no recibirá asignaciones de ganancias. Una vez aprobada, su cuenta se cerrará y se creará un retiro final por su saldo completo.",
    "cancelButton": "Cancelar Solicitud de Cierre",
    "exitedTitle": "Cuenta Cerrada",
    "exitedMessage": "Su cuenta ha sido cerrada y ya no está participando en el fondo. No se le asignarán nuevas ganancias.",
    "exitedAt": "Fecha efectiva",
    "historyAvailable": "Aún puede ver su historial de contribuciones, liquidaciones y retiros a continuación."
  }
}
